
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/album/[uuid]",
      function () {
        return require("private-next-pages/media/album/[uuid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media/album/[uuid]"])
      });
    }
  